module.exports = __webpack_public_path__ + "img/mermaid_man.de83c264.jpg";